import { render, staticRenderFns } from "./productProperties.vue?vue&type=template&id=e63567ba&scoped=true"
import script from "./productProperties.vue?vue&type=script&lang=js"
export * from "./productProperties.vue?vue&type=script&lang=js"
import style0 from "./productProperties.vue?vue&type=style&index=0&id=e63567ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63567ba",
  null
  
)

export default component.exports